import themeFallback from '@/data/theme.json';

export default {
  async SET_THEME({ commit }, { theme }) {
    try {
      let { business_info, styles } = theme;

      if (typeof business_info === 'string') {
        business_info = JSON.parse(business_info);
        styles = JSON.parse(styles);
      }

      if (!business_info || !styles) {
        throw new Error('invalid theme shape');
      }

      await commit('SET_THEME', {
        name: theme.name,
        document: theme.document,
        business_info,
        styles,
      });
    } catch {
      await commit('SET_THEME', { ...themeFallback });
    }
  },
};
